export default __webpack_public_path__ + "static/media/img-16.a40a6bfa.jpg";